<template>
  <div class="div-wrapper-subsection">
    <div class="group-11">
      <div class="text-wrapper-15">Corporate culture</div>
      <div class="text-wrapper-16">企业文化</div>
    </div>
    <div class="group-12">
      <p class="div-2">
        <span class="span">云帆培优</span>
        <span class="text-wrapper-17">价值观</span>
      </p>
      <div class="text-wrapper-18">教不好学生等于偷钱抢钱，负责任的老师才受到尊重。</div>
    </div>
    <div class="group-13">
      <p class="div-3">
        <span class="span">云帆培优</span>
        <span class="text-wrapper-17">使命</span>
      </p>
      <div class="text-wrapper-19">提高石家庄基础教育水平</div>
    </div>
    <div class="group-14">
      <p class="div-4">
        <span class="span">云帆培优</span>
        <span class="text-wrapper-17">愿景</span>
      </p>
      <div class="text-wrapper-20">成为受尊敬的教育公司</div>
    </div>
  </div>
</template>

<script>
export default { name: "DivWrapperSubsection" };
</script>

<style scoped>
.div-wrapper-subsection { background-image: url(https://c.animaapp.com/HolSXyOa/img/rectangle-82.png); background-position: 50% 50%; background-size: cover; display: flex; flex-direction: column; height: 867px; left: 0; position: absolute; top: 3838px; width: 1920px; }
.div-wrapper-subsection .group-11 { height: 63px; margin-left: 186px; margin-top: 103px; position: relative; width: 408px; }
.div-wrapper-subsection .text-wrapper-15 { align-items: center; color: #ffffff1a; display: flex; font-family: "PingFang SC-Semibold", Helvetica; font-size: 48px; font-weight: 400; height: 40px; justify-content: center; left: 0; letter-spacing: 0; line-height: 40px; position: absolute; top: 23px; white-space: nowrap; }
.div-wrapper-subsection .text-wrapper-16 { align-items: center; color: #ffffff; display: flex; font-family: "PingFang SC-Semibold", Helvetica; font-size: 48px; font-weight: 400; height: 40px; justify-content: center; left: 0; letter-spacing: 0; line-height: 40px; position: absolute; top: 0; white-space: nowrap; }
.div-wrapper-subsection .group-12 { display: flex; flex-direction: column; height: 104px; margin-left: 592px; margin-top: 120px; width: 740px; }
.div-wrapper-subsection .div-2 { color: transparent; font-family: "PingFang SC-Light", Helvetica; font-size: 24px; font-weight: 400; height: 52px; letter-spacing: 0; line-height: 52px; margin-left: 266px; white-space: nowrap; width: 204px; }
.div-wrapper-subsection .span { color: #ffffff; font-weight: 300; }
.div-wrapper-subsection .text-wrapper-17 { color: #0695e0; font-family: "PingFang SC-Medium", Helvetica; font-weight: 500; }
.div-wrapper-subsection .text-wrapper-18 { color: #ffffff; font-family: "PingFang SC-Medium", Helvetica; font-size: 32px; font-weight: 500; height: 52px; letter-spacing: 0; line-height: 52px; white-space: nowrap; width: 736px; }
.div-wrapper-subsection .group-13 { display: flex; flex-direction: column; gap: 6px; height: 110px; margin-left: 784px; margin-top: 60px; width: 356px; }
.div-wrapper-subsection .div-3 { color: transparent; font-family: "PingFang SC-Light", Helvetica; font-size: 24px; font-weight: 400; height: 52px; letter-spacing: 0; line-height: 52px; margin-left: 86px; white-space: nowrap; width: 180px; }
.div-wrapper-subsection .text-wrapper-19 { color: #ffffff; font-family: "PingFang SC-Medium", Helvetica; font-size: 32px; font-weight: 500; height: 52px; letter-spacing: 0; line-height: 52px; white-space: nowrap; width: 352px; }
.div-wrapper-subsection .group-14 { display: flex; flex-direction: column; gap: 6px; height: 110px; margin-left: 800px; margin-top: 60px; width: 324px; }
.div-wrapper-subsection .div-4 { color: transparent; font-family: "PingFang SC-Light", Helvetica; font-size: 24px; font-weight: 400; height: 52px; letter-spacing: 0; line-height: 52px; margin-left: 70px; white-space: nowrap; width: 180px; }
.div-wrapper-subsection .text-wrapper-20 { color: #ffffff; font-family: "PingFang SC-Medium", Helvetica; font-size: 32px; font-weight: 500; height: 52px; letter-spacing: 0; line-height: 52px; white-space: nowrap; width: 320px; }
</style>
